import React, {useContext} from 'react';
import {Link, Navigate } from 'react-router-dom';
import RequireAuth from "../auth/RequireAuth";
import { Header } from './Header';
import CredentialsContext from "../contexts/CredentialsContext";

import "./dashboard.css";
import "../css/buttons.css";

export default function Dashboard() {
  const {credentials} = useContext(CredentialsContext);

  if (!credentials) {
    return <Navigate to="/login" />
  }

  return(
    <>
    <Header/>
    <h1 className="centering">Панель управления</h1>
    <p className="centering main-text">Выберите нужное действие</p>
    <div className='action-list'>
      <Link className='btn btn-default' to="/games">
        <div>Оставить комментарии к играм</div>
      </Link>
      <Link className='btn btn-default' to="/comments">
        <div>Посмотреть список комментариев к играм</div>
      </Link>
      <RequireAuth roles={["admin", "developer"]} public={false}>
        <Link className='btn btn-default' to="/admin">
        <div>Управление пользователями</div>
        </Link>
      </RequireAuth>
    </div>
    </>
  );
}